export default __webpack_public_path__ + "static/media/PASION.73752464.jpg";